
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2883',
  depVersions: {
  "customer-portal-app": "static-1.2883",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.489",
  "data-fetching-client": "static-1.9841",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25917",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5774",
  "hs-test-utils": "static-1.8205",
  "hub-http": "static-1.6401",
  "hub-http-shared-msw-handlers": "static-1.10409",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18759",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11657",
  "I18n": "static-7.1646",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6638",
  "payment-link-components": "static-1.23930",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7274",
  "quartz-core": "static-1.6493",
  "quartz-i18n": "static-1.949",
  "react": "static-7.189",
  "react-colorpicker": "static-2.10390",
  "react-dlb": "static-1.83",
  "react-utils": "static-2.5469",
  "reselect": "static-3.8",
  "rich-text-lib": "static-1.20145",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18229",
  "ui-components-test-utils": "static-1.5794",
  "UIComponents": "static-3.8603",
  "foundations-assets": "static-1.5055",
  "foundations-components": "static-1.8284",
  "foundations-theming": "static-1.4620",
  "foundations-theming-specialty": "static-1.2336",
  "framer-motion": "static-1.75",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1249",
  "quartz-config": "static-1.1052",
  "quartz-routing": "static-1.704",
  "quick-fetch": "static-1.4046",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16884",
  "rpc-client-utils": "static-1.4839",
  "sanitize-text": "static-1.8327",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.58",
  "ui-addon-draggable": "static-3.4939",
  "ui-addon-react-router-dom": "static-1.9716",
  "usage-tracker": "static-1.7533",
  "usage-tracker-anonymous": "static-1.5950",
  "usage-tracker-core": "static-1.7383",
  "video-components-external": "static-1.11874",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3529",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3551",
  "quartz-webpack": "static-1.3498",
  "bend-plugin-quartz-routing": "static-1.352",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.85",
  "customer-data-objects": "static-1.7862",
  "frontend-preferences-client": "static-1.8109",
  "laboratory-lib": "static-3.7333",
  "onboarding-scopes": "static-1.6641",
  "seat-types-lib": "static-1.410",
  "ui-addon-opt": "static-4.8543",
  "HeadJS": "static-2.778",
  "hs-test-utils-bend-plugin": "static-1.3316",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "hs-locale-management": "static-1.209",
  "ts-schema": "static-1.4208",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8031",
  "content-media-capture": "static-1.5107",
  "cssUtils": "static-1.844",
  "customer-data-ui-utilities": "static-1.10007",
  "file-manager-components": "static-1.24160",
  "HubStyle": "static-2.11964",
  "knowledge-content-types": "static-1.8584",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.491",
  "ui-addon-emoji-picker": "static-1.10066",
  "ui-addon-i18n": "static-1.11329",
  "ui-business-units-lib": "static-1.9262",
  "ui-shepherd-react": "static-3.10443",
  "video-data-lib": "static-1.35532",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4505",
  "commerce-tours-lib": "static-1.6440",
  "customer-data-properties": "static-1.52199",
  "getting-started-shared-tasks": "static-1.18950",
  "growth-onboarding-reliability": "static-1.5263",
  "onboarding-tours": "static-1.16943",
  "reference-resolvers-lite": "static-1.8279",
  "sales-checkout-service-client": "static-1.3743",
  "ui-addon-iframeable": "static-1.9257",
  "user-context": "static-1.5293",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.853",
  "hubspotter-http": "static-1.4779",
  "icons": "static-2.666",
  "mobile-manifest-mixins": "static-1.552",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.949",
  "quartz-head": "static-1.939",
  "quartz-test": "static-1.949",
  "quartz-tracking": "static-1.653",
  "trellis-components": "static-1.2313",
  "ui-fonts": "static-1.919",
  "usage-tracker-container": "static-1.7523",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9608",
  "data-token-picker": "static-1.16726",
  "FileManagerLib": "static-1.39800",
  "property-translator": "static-1.5575",
  "atom": "static-1.5257",
  "merchandise-lib": "static-1.268",
  "purchase-motions-components": "static-1.6183",
  "salesImages": "static-1.529",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5767",
  "react-create-root-preference": "static-1.46",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.102",
  "ui-images": "static-2.1207",
  "bend-plugin-foundations-components": "static-1.4553",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "trellis-assets": "static-1.2294",
  "bend-plugin-foundations-theming": "static-1.3103",
  "foundations-theming-base": "static-1.3605",
  "stylex": "static-1.37",
  "interframe": "static-3.4938",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5947",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.249",
  "chirp-fetch": "static-1.2069",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4659",
  "react-flip-move": "static-1.74",
  "apollo-link-hub-http": "static-2.4834",
  "content-media-composition-data-lib": "static-1.12911",
  "content-media-compositions": "static-2.16918",
  "idb-keyval": "static-1.47",
  "immer": "static-1.33",
  "immerable": "static-1.4330",
  "magpie-lib": "static-1.5676",
  "magpie-types": "static-1.5136",
  "media-bridge-lib": "static-1.19241",
  "bender-build-tools": "static-1.3316",
  "inbound-db-properties-service-client": "static-1.3974",
  "superstore": "static-1.4940",
  "feedback-loader": "static-1.29634",
  "ai-components-ui-library": "static-1.9419",
  "ui-addon-video-player": "static-1.8889",
  "ui-coaching-tips": "static-1.29069",
  "ContentUtils": "static-1.68902",
  "fix-webm-duration": "static-1.26",
  "notification-sounds": "static-1.4607",
  "sassPrefix": "static-1.160",
  "react-dnd-compat": "static-1.4796",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1364",
  "copilot-toolkit": "static-1.11602",
  "avatar-components": "static-1.2681",
  "navigation-messaging": "static-1.7851",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8357",
  "commerce-products-lib": "static-1.10238",
  "crm-message-bus": "static-1.43499",
  "growth-data-modal": "static-1.5725",
  "hubspot-apollo-client": "static-1.5058",
  "onboarding-tours-client": "static-1.5157",
  "calling-global-api": "static-1.65129",
  "calling-internal-common": "static-1.31494",
  "calling-lifecycle-internal": "static-1.66511",
  "calling-lifecycle-messages": "static-1.58805",
  "conditional-properties-service-client": "static-1.3925",
  "crm-links": "static-1.6497",
  "crm-pipelines-api-client-types": "static-1.4266",
  "customer-data-objects-ui-components": "static-1.13213",
  "customer-data-properties-shared-msw-handlers": "static-1.9736",
  "customer-data-property-utils": "static-1.8279",
  "external-options-client-types": "static-1.4254",
  "formula-editor": "static-1.14579",
  "framework-data-schema-resolvers": "static-1.7076",
  "google-libphonenumber": "static-1.41",
  "hs-resources": "static-1.360",
  "inbound-db-meta-service-client": "static-1.3716",
  "inbounddb-objects-service-types": "static-1.4345",
  "meetings-icalendar-utils-lib": "static-1.814",
  "multi-currency-client-types": "static-1.3820",
  "object-builder-ui-client": "static-1.49339",
  "pipeline-validation-client-types": "static-1.4095",
  "property-value-citations": "static-1.2813",
  "pulse": "static-1.797",
  "smart-property-lib": "static-1.8065",
  "tiered-pricing": "static-1.1732",
  "topics-actions-lib": "static-1.332",
  "ui-addon-form-validation": "static-1.11171",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3244",
  "growth-onboarding-next-action-utils": "static-1.2452",
  "navigation-components": "static-1.18524",
  "onboarding-tours-utils": "static-1.1009",
  "ui-shepherd-tracker": "static-1.7824",
  "ui-universal-auth": "static-1.9192",
  "batch-promise": "static-1.1727",
  "getting-started-shared-tasks-store": "static-1.18068",
  "hubspotter-http-shared-msw-handlers": "static-1.10407",
  "usage-tracker-session-replay": "static-1.5219",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1130",
  "tanstack-virtual": "static-1.33",
  "audio-components": "static-1.6185",
  "FileManagerCore": "static-1.39659",
  "FileManagerImages": "static-1.37311",
  "video-components": "static-1.13876",
  "foundations-components-legacy": "static-1.1309",
  "purchase-motions-api": "static-1.6186",
  "signup-constants": "static-1.19332",
  "signup-ui-url-generator": "static-2.8241",
  "usage-tracker-public": "static-1.7344",
  "reactive-lib": "static-1.906",
  "simple-logging-lib": "static-1.3231",
  "chatspot-core": "static-1.22234",
  "growth-onboarding-feedback-components": "static-1.6762",
  "cms-field-types": "static-1.4997",
  "content-icons-ui": "static-1.2280",
  "integrations-lib": "static-1.16735",
  "underscore": "static-1.8",
  "breeze-engine-core": "static-1.642",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.957",
  "customer-data-tracking": "static-1.7067",
  "products-iframe-lib": "static-1.8371",
  "products-ui-components-shared-msw-handlers": "static-1.10791",
  "restore-request-side-panel-lib": "static-1.1374",
  "onboarding-data-sync-lib": "static-1.2271",
  "hubspot-apollo-cache": "static-1.517",
  "calling-error-reporting": "static-1.31501",
  "shared-worker-versioning": "static-1.11218",
  "calling-usage-tracker": "static-1.6722",
  "voice-sms-access-library": "static-1.1649",
  "conversations-skeleton-state": "static-1.7430",
  "location-customization-utils-lib": "static-1.9800",
  "bark-lib": "static-1.16671",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.98",
  "crm-properties-common-lib": "static-1.6069",
  "react-codemirror": "static-1.10816",
  "fdsr-migration-layer": "static-1.195",
  "framework-builder-read-service-client": "static-1.4134",
  "framework-data-schema-quick-fetch": "static-1.6981",
  "persist-promise": "static-1.3884",
  "event-emitter": "static-1.1132",
  "bend-plugin-pulse": "static-1.300",
  "fast-json-patch": "static-1.66",
  "data-agent-kit": "static-1.482",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10492",
  "fsm": "static-1.3912",
  "policy-lib": "static-1.6968",
  "react-tinymce": "static-1.55728",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10555",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54854",
  "tinymce-plugins": "static-1.57968",
  "tinymce-themes": "static-1.56824",
  "growth-onboarding-next-action-components": "static-1.2480",
  "user-context-client": "static-1.4733",
  "nest": "static-1.417",
  "unified-auth-core-lib": "static-1.988",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.57",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4713",
  "video-embed": "static-1.36366",
  "social-insights-client-types": "static-1.22557",
  "flux-actions": "static-1.353",
  "integrations-error-boundary-lib": "static-1.14150",
  "integrations-tracking-lib": "static-1.5789",
  "native-integrations-shared-strings": "static-1.7962",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10546",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.706",
  "sales-views-client-types": "static-1.4440",
  "InboxConnectUtils": "static-4.15306",
  "meetings-connect-utils-lib": "static-1.7788",
  "calling-orchestration-schema": "static-1.36426",
  "crm-record-cards-service-types": "static-1.3713",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16104",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.107",
  "trellis-story-utils": "static-1.4689",
  "storybook-react": "static-1.36",
  "hub-http-contrib": "static-1.3225",
  "tinymce-data": "static-1.40939",
  "ui-addon-sales-email": "static-1.5395",
  "layout-dnd-components": "static-1.12794",
  "layout-dnd-utils": "static-1.11769",
  "ui-brand-identity-lib": "static-1.15960",
  "NamespacedHubStyle": "static-2.9179",
  "outpost": "static-1.4348",
  "universal-page-editor-lib": "static-1.3194",
  "adobe-sign-auth-lib": "static-1.212",
  "ads-unified-auth-lib": "static-1.703",
  "google-sheets-integration-lib": "static-1.779",
  "microsoft-drive-integration-lib": "static-1.885",
  "surveymonkey-integration-lib": "static-1.228",
  "slack-ui-library": "static-1.10580",
  "ContentData": "static-1.68977",
  "layout-data-lib": "static-1.10094",
  "advanced-menus-core": "static-1.15427",
  "advanced-menus-lib": "static-1.12321",
  "ExportDialog": "static-6.10561",
  "ui-memberships-settings-lib": "static-1.34550",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15426",
  "simple-menus-lib": "static-1.16943"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2883",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.489",
  "data-fetching-client": "/data-fetching-client/static-1.9841",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25917",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5774",
  "hs-test-utils": "/hs-test-utils/static-1.8205",
  "hub-http": "/hub-http/static-1.6401",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10409",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18759",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11657",
  "I18n": "/I18n/static-7.1646",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6638",
  "payment-link-components": "/payment-link-components/static-1.23930",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7274",
  "quartz-core": "/quartz-core/static-1.6493",
  "quartz-i18n": "/quartz-i18n/static-1.949",
  "react": "/react/static-7.189",
  "react-colorpicker": "/react-colorpicker/static-2.10390",
  "react-dlb": "/react-dlb/static-1.83",
  "react-utils": "/react-utils/static-2.5469",
  "reselect": "/reselect/static-3.8",
  "rich-text-lib": "/rich-text-lib/static-1.20145",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18229",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5794",
  "UIComponents": "/UIComponents/static-3.8603",
  "foundations-assets": "/foundations-assets/static-1.5055",
  "foundations-components": "/foundations-components/static-1.8284",
  "foundations-theming": "/foundations-theming/static-1.4620",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2336",
  "framer-motion": "/framer-motion/static-1.75",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1249",
  "quartz-config": "/quartz-config/static-1.1052",
  "quartz-routing": "/quartz-routing/static-1.704",
  "quick-fetch": "/quick-fetch/static-1.4046",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16884",
  "rpc-client-utils": "/rpc-client-utils/static-1.4839",
  "sanitize-text": "/sanitize-text/static-1.8327",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.58",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4939",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9716",
  "usage-tracker": "/usage-tracker/static-1.7533",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5950",
  "usage-tracker-core": "/usage-tracker-core/static-1.7383",
  "video-components-external": "/video-components-external/static-1.11874",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3529",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3551",
  "quartz-webpack": "/quartz-webpack/static-1.3498",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.352",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.85",
  "customer-data-objects": "/customer-data-objects/static-1.7862",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8109",
  "laboratory-lib": "/laboratory-lib/static-3.7333",
  "onboarding-scopes": "/onboarding-scopes/static-1.6641",
  "seat-types-lib": "/seat-types-lib/static-1.410",
  "ui-addon-opt": "/ui-addon-opt/static-4.8543",
  "HeadJS": "/HeadJS/static-2.778",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3316",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "hs-locale-management": "/hs-locale-management/static-1.209",
  "ts-schema": "/ts-schema/static-1.4208",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8031",
  "content-media-capture": "/content-media-capture/static-1.5107",
  "cssUtils": "/cssUtils/static-1.844",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10007",
  "file-manager-components": "/file-manager-components/static-1.24160",
  "HubStyle": "/HubStyle/static-2.11964",
  "knowledge-content-types": "/knowledge-content-types/static-1.8584",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10066",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11329",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9262",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10443",
  "video-data-lib": "/video-data-lib/static-1.35532",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4505",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6440",
  "customer-data-properties": "/customer-data-properties/static-1.52199",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18950",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5263",
  "onboarding-tours": "/onboarding-tours/static-1.16943",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8279",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3743",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9257",
  "user-context": "/user-context/static-1.5293",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.853",
  "hubspotter-http": "/hubspotter-http/static-1.4779",
  "icons": "/icons/static-2.666",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.552",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.949",
  "quartz-head": "/quartz-head/static-1.939",
  "quartz-test": "/quartz-test/static-1.949",
  "quartz-tracking": "/quartz-tracking/static-1.653",
  "trellis-components": "/trellis-components/static-1.2313",
  "ui-fonts": "/ui-fonts/static-1.919",
  "usage-tracker-container": "/usage-tracker-container/static-1.7523",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9608",
  "data-token-picker": "/data-token-picker/static-1.16726",
  "FileManagerLib": "/FileManagerLib/static-1.39800",
  "property-translator": "/property-translator/static-1.5575",
  "atom": "/atom/static-1.5257",
  "merchandise-lib": "/merchandise-lib/static-1.268",
  "purchase-motions-components": "/purchase-motions-components/static-1.6183",
  "salesImages": "/salesImages/static-1.529",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5767",
  "react-create-root-preference": "/react-create-root-preference/static-1.46",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.102",
  "ui-images": "/ui-images/static-2.1207",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4553",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "trellis-assets": "/trellis-assets/static-1.2294",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3103",
  "foundations-theming-base": "/foundations-theming-base/static-1.3605",
  "stylex": "/stylex/static-1.37",
  "interframe": "/interframe/static-3.4938",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5947",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.249",
  "chirp-fetch": "/chirp-fetch/static-1.2069",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4659",
  "react-flip-move": "/react-flip-move/static-1.74",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4834",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12911",
  "content-media-compositions": "/content-media-compositions/static-2.16918",
  "idb-keyval": "/idb-keyval/static-1.47",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4330",
  "magpie-lib": "/magpie-lib/static-1.5676",
  "magpie-types": "/magpie-types/static-1.5136",
  "media-bridge-lib": "/media-bridge-lib/static-1.19241",
  "bender-build-tools": "/bender-build-tools/static-1.3316",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3974",
  "superstore": "/superstore/static-1.4940",
  "feedback-loader": "/feedback-loader/static-1.29634",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9419",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8889",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29069",
  "ContentUtils": "/ContentUtils/static-1.68902",
  "fix-webm-duration": "/fix-webm-duration/static-1.26",
  "notification-sounds": "/notification-sounds/static-1.4607",
  "sassPrefix": "/sassPrefix/static-1.160",
  "react-dnd-compat": "/react-dnd-compat/static-1.4796",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1364",
  "copilot-toolkit": "/copilot-toolkit/static-1.11602",
  "avatar-components": "/avatar-components/static-1.2681",
  "navigation-messaging": "/navigation-messaging/static-1.7851",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8357",
  "commerce-products-lib": "/commerce-products-lib/static-1.10238",
  "crm-message-bus": "/crm-message-bus/static-1.43499",
  "growth-data-modal": "/growth-data-modal/static-1.5725",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5058",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5157",
  "calling-global-api": "/calling-global-api/static-1.65129",
  "calling-internal-common": "/calling-internal-common/static-1.31494",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66511",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58805",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3925",
  "crm-links": "/crm-links/static-1.6497",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4266",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13213",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9736",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8279",
  "external-options-client-types": "/external-options-client-types/static-1.4254",
  "formula-editor": "/formula-editor/static-1.14579",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7076",
  "google-libphonenumber": "/google-libphonenumber/static-1.41",
  "hs-resources": "/hs-resources/static-1.360",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3716",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4345",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.814",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3820",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49339",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4095",
  "property-value-citations": "/property-value-citations/static-1.2813",
  "pulse": "/pulse/static-1.797",
  "smart-property-lib": "/smart-property-lib/static-1.8065",
  "tiered-pricing": "/tiered-pricing/static-1.1732",
  "topics-actions-lib": "/topics-actions-lib/static-1.332",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11171",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3244",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2452",
  "navigation-components": "/navigation-components/static-1.18524",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1009",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7824",
  "ui-universal-auth": "/ui-universal-auth/static-1.9192",
  "batch-promise": "/batch-promise/static-1.1727",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18068",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10407",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5219",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1130",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "audio-components": "/audio-components/static-1.6185",
  "FileManagerCore": "/FileManagerCore/static-1.39659",
  "FileManagerImages": "/FileManagerImages/static-1.37311",
  "video-components": "/video-components/static-1.13876",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1309",
  "purchase-motions-api": "/purchase-motions-api/static-1.6186",
  "signup-constants": "/signup-constants/static-1.19332",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8241",
  "usage-tracker-public": "/usage-tracker-public/static-1.7344",
  "reactive-lib": "/reactive-lib/static-1.906",
  "simple-logging-lib": "/simple-logging-lib/static-1.3231",
  "chatspot-core": "/chatspot-core/static-1.22234",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6762",
  "cms-field-types": "/cms-field-types/static-1.4997",
  "content-icons-ui": "/content-icons-ui/static-1.2280",
  "integrations-lib": "/integrations-lib/static-1.16735",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-core": "/breeze-engine-core/static-1.642",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.957",
  "customer-data-tracking": "/customer-data-tracking/static-1.7067",
  "products-iframe-lib": "/products-iframe-lib/static-1.8371",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10791",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1374",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2271",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.517",
  "calling-error-reporting": "/calling-error-reporting/static-1.31501",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11218",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6722",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1649",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7430",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9800",
  "bark-lib": "/bark-lib/static-1.16671",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.98",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6069",
  "react-codemirror": "/react-codemirror/static-1.10816",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.195",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4134",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6981",
  "persist-promise": "/persist-promise/static-1.3884",
  "event-emitter": "/event-emitter/static-1.1132",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.300",
  "fast-json-patch": "/fast-json-patch/static-1.66",
  "data-agent-kit": "/data-agent-kit/static-1.482",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10492",
  "fsm": "/fsm/static-1.3912",
  "policy-lib": "/policy-lib/static-1.6968",
  "react-tinymce": "/react-tinymce/static-1.55728",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10555",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54854",
  "tinymce-plugins": "/tinymce-plugins/static-1.57968",
  "tinymce-themes": "/tinymce-themes/static-1.56824",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2480",
  "user-context-client": "/user-context-client/static-1.4733",
  "nest": "/nest/static-1.417",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.988",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.57",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4713",
  "video-embed": "/video-embed/static-1.36366",
  "social-insights-client-types": "/social-insights-client-types/static-1.22557",
  "flux-actions": "/flux-actions/static-1.353",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14150",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5789",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7962",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10546",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.706",
  "sales-views-client-types": "/sales-views-client-types/static-1.4440",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15306",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7788",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36426",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3713",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16104",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.107",
  "trellis-story-utils": "/trellis-story-utils/static-1.4689",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-contrib": "/hub-http-contrib/static-1.3225",
  "tinymce-data": "/tinymce-data/static-1.40939",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5395",
  "layout-dnd-components": "/layout-dnd-components/static-1.12794",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11769",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15960",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9179",
  "outpost": "/outpost/static-1.4348",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3194",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.212",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.703",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.779",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.885",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.228",
  "slack-ui-library": "/slack-ui-library/static-1.10580",
  "ContentData": "/ContentData/static-1.68977",
  "layout-data-lib": "/layout-data-lib/static-1.10094",
  "advanced-menus-core": "/advanced-menus-core/static-1.15427",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12321",
  "ExportDialog": "/ExportDialog/static-6.10561",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34550",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15426",
  "simple-menus-lib": "/simple-menus-lib/static-1.16943"
}
};
